import { render, staticRenderFns } from "./projects-list.vue?vue&type=template&id=27cceb4b&"
import script from "./projects-list.vue?vue&type=script&lang=js&"
export * from "./projects-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports